import { maxPool } from '../../ops/max_pool';
import { getGlobalTensorClass } from '../../tensor';
getGlobalTensorClass().prototype.maxPool =
    function (filterSize, strides, pad, dimRoundingMode) {
        this.throwIfDisposed();
        return maxPool(this, filterSize, strides, pad, dimRoundingMode);
    };
//# sourceMappingURL=max_pool.js.map